import React from "react";
import {Button, Timeline} from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import { formatMoney, formatExchangeRate, displayNumberWithComma } from "utils/utils";
import "./TrackAndTracePanel.scss";
import {downloadOrderReceipt} from "../api/api";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

class TimelineOrderProcessing extends React.Component {
    downloadOrder = () => {
        downloadOrderReceipt('order',this.props.order.id, this.props.order.orderId);
    };
  render() {
    return (
      <Timeline className="track-and-trace-timeline">
        <Timeline.Item dot={<CompletedItemIcon />}>
          <span className="timeline-completed-item"><FormattedMessage id="app.panel.timelineorder.ordersetup"/></span>
          {this.props.order.dateCreated && (
            <div className="timeline-hint-label bp-margin-top-smallest-2">
              <FormattedMessage id="app.panel.timelineorder.completedon"/>{" "}
              {moment(this.props.order.dateCreated).format("MMM DD, YYYY")}
            </div>
          )}
        </Timeline.Item>
        <Timeline.Item dot={<CompletedItemIcon />}>
          <span className="timeline-completed-item">
            <FormattedMessage id="app.panel.timelineorder.waitingpayment"/>
          </span>
          {this.props.order.dateReceived && (
            <div className="timeline-hint-label bp-margin-top-smallest-2">
              <FormattedMessage id="app.panel.timelineorder.completedon"/>{" "}
              {moment(this.props.order.dateReceived).format("MMM DD, YYYY")}
            </div>
          )}
        </Timeline.Item>
        <Timeline.Item dot={<CompletedItemIcon />}>
          <span className="timeline-completed-item">
          <FormattedMessage id="app.panel.timelineorder.payouttobeneficiary"/>{' '}<a href="#" onClick={this.downloadOrder}>(<FormattedMessage id="app.panel.timelineorder.receipt"/>)</a>
          </span>
          <div className="bp-small-bordered-panel bp-margin-top-smallest">
          <FormattedMessage id="app.panel.timelineorder.processingpayout"/>{" "}
            <span className="bp-bold">
              {displayNumberWithComma(this.props.order.targetAmount)}{" "}
              {this.props.order.targetCurrency}
            </span>{" "}
            <FormattedMessage id="app.panel.timelineorder.to"/>{" "}
            <span className="bp-bold">
              {this.props.order.beneficiary.fullName}
            </span>
            <FormattedMessage id="app.panel.timelineorder.transferrate"/>{" "}
            <span className="bp-bold">
              {formatExchangeRate(this.props.order.exchangeRate)}
            </span>{" "}
            {this.props.order.sourceCurrency}/{this.props.order.targetCurrency}
          </div>
        </Timeline.Item>
        <Timeline.Item dot={<NotCompletedItemIcon />}>
          <span className="timeline-not-completed-item">
          <FormattedMessage id="app.panel.timelineorder.ordercompleted"/>
          </span>
        </Timeline.Item>
      </Timeline>
    );
  }
}

function CompletedItemIcon() {
    return <div className="timeline-dot-completed" />;
  }
  
  function NotCompletedItemIcon() {
    return <div className="timeline-dot-not-completed" />;
  }

export default withUseIntl(TimelineOrderProcessing);